// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"d68252ca","682":"a1bc0220"}[chunkId] + ".chunk.css";
};